/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { MODAL_CONFIRM_CHANGING_PLAN } from './constants'
import ConfirmChangingPlanModal from './ConfirmChangingPlanModalContainer'

export {
  MODAL_CONFIRM_CHANGING_PLAN
}

export default ConfirmChangingPlanModal
